import CPanel from "../CPanel";

export default {
    CPanel: {
        path: "/cpanel",
        name: "CPanel",
        component: CPanel,
        icon: "fa fa-laptop",
        meta: { roles: ['manager', 'administrator'] },
    },
    Setting: {
        path: "/cpanel/setting",
        name: "Setting",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    UpdatePassword: {
        path: "/cpanel/password",
        name: "UpdatePassword",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    Orders: {
        path: "/cpanel/orders",
        name: "Orders",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    Devices: {
        path: "/cpanel/devices",
        name: "Devices",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    Services: {
        path: "/cpanel/services",
        name: "Services",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    ServiceEdit: {
        path: "/cpanel/service/edit/:uid",
        name: "ServiceEdit",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    ServicePopup: {
        path: "/cpanel/service/popup",
        name: "ServicePopup",
        component: CPanel,
        meta: { roles: ['administrator'] },
    },
    Proceed: {
        path: "/cpanel/proceed",
        name: "Proceed",
        component: CPanel,
        meta: { roles: ['administrator'] },
    }
};
